module.exports = __webpack_public_path__ + "static/media/left-arrow.e0655d7a.png";